import { BsFillPlusCircleFill } from "react-icons/bs";

function FilterFreeContent({ AddNewContent, OpenFilter }) {
    return (
        <div className="bg-purpleLight border border-slate-200 rounded-lg w95 mx-4 mt-2 mb-1 p-2 flex flex-row-reverse justify-between">

            <div onClick={() => OpenFilter(true)}
                className="flex flex-row-reverse items-center">
                <img src="/image/icon/filter.png" className="w-7" />
                <p className="text-xs t-purpleDark mr-2">فیلتر</p>
            </div>

            <div
                onClick={() => AddNewContent(true)}
                className="flex flex-row-reverse items-center bg-white t-purpleDark px-2 py-1 rounded border border-slate-200"
            >
                <BsFillPlusCircleFill size={22} />
                <p className="text-xs font-bold mr-2">محتوای جدید</p>
            </div>
        </div>
    )
}
export default FilterFreeContent;